import breakpoints from '../visid/breakpoints';
var containerSizeHandler = function containerSizeHandler(prop, width) {
  if (!prop[1]) {
    return prop[0];
  }
  if (width < breakpoints.sm[1] && prop[1].sm) {
    return prop[1].sm;
  }
  if (width < breakpoints.md[1] && prop[1].md) {
    return prop[1].md;
  }
  if (width < breakpoints.lg[1] && prop[1].lg) {
    return prop[1].lg;
  }
  return prop[1].xl ? prop[1].xl : prop[0];
};
var containerSizeStyleSwitcher = function containerSizeStyleSwitcher(value, containerSize) {
  if (value && Array.isArray(value)) {
    if (!containerSize.width) {
      return value[0];
    } else {
      return containerSizeHandler(value, containerSize.width);
    }
  }
  return value;
};
export default containerSizeStyleSwitcher;